export { default } from './RegistrationSteps'



// WEBPACK FOOTER //
// ./src/App/components/RegistrationSteps/index.js